import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { InfoTip } from "@/components/InfoTip";

// Shared full-width blue bar used by "Action en 1 clic", "Actions sur le résumé",
// "Retravailler ce résumé" and "Question de suivi" so they all look identical.
export function ActionBarButton({ icon: Icon, label, onClick, testid, tip, help, pulse = false, badge, chevron = true, disabled = false, className = "" }) {
  return (
    <div className="relative">
    <button
      type="button"
      data-testid={testid}
      data-tip={tip}
      onClick={onClick}
      disabled={disabled}
      className={`${pulse ? "sux-pulse-ring " : ""}w-full flex items-center justify-center gap-3 bg-[#002FA7] text-white border border-[#002FA7] hover:bg-[#001a66] ${help ? "px-12" : "px-4"} py-4 transition-colors disabled:opacity-50 ${className}`}
    >
      <Icon className="w-5 h-5 shrink-0" />
      <span className="font-mono uppercase tracking-[0.18em] text-[13px] font-semibold">{label}</span>
      {badge && (
        <span className="inline-block px-1.5 py-0.5 bg-white text-[#002FA7] font-mono uppercase tracking-[0.15em] text-[9px]">
          {badge}
        </span>
      )}
      {chevron && <ChevronDown className="w-4 h-4 shrink-0" />}
    </button>
    {help && (
      <div className="absolute right-3 top-1/2 -translate-y-1/2">
        <InfoTip light content={help} testid={`${testid}-info`} />
      </div>
    )}
    </div>
  );
}

// Header of an expanded panel: same blue bar, centered title, collapse button on the right.
export function ActionBarHeader({ icon: Icon, label, onCollapse, testid, extra }) {
  return (
    <div className="relative flex items-center justify-center px-16 py-3 bg-[#002FA7] text-white">
      <div className="flex items-center gap-2 min-w-0">
        <Icon className="w-4 h-4 shrink-0" />
        <span className="font-mono uppercase tracking-[0.15em] text-[12px] font-semibold truncate">{label}</span>
      </div>
      <div className="absolute right-4 top-1/2 -translate-y-1/2 flex items-center gap-2 shrink-0">
        {extra}
        <button type="button" data-testid={testid} onClick={onCollapse} className="text-white/80 hover:text-white" data-tip="Replier ce panneau." aria-label="Replier">
          <ChevronUp className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

// Option chip: turns blue with white text when it is the selected option.
export const optionCls = (active) =>
  `font-mono uppercase tracking-[0.14em] text-[11px] px-3 py-2 border transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${
    active ? "bg-[#002FA7] text-white border-[#002FA7]" : "border-border bg-background hover:bg-[#002FA7] hover:text-white hover:border-[#002FA7]"
  }`;

export const menuItemCls = (active) =>
  `font-['IBM_Plex_Sans'] text-sm cursor-pointer ${active ? "!bg-[#002FA7] !text-white" : ""}`;
